<template>
  <div class="editAppointment">
    <div v-show="addAppointment">
      <van-sticky>
        <div class="header">
          <van-icon name="arrow-left" color="#fff" class="vanIconText" @click="returnIndex" />
          <span class="addInfo">复制预约</span>
        </div>
      </van-sticky>
      <div class="content">
        <div ref="deptSort">
          <van-form :v-model="form">
            <div class="appointTop">
              <div>
                <div class="appointInfo">客人:</div>
                <input type="text" placeholder="请输入名字" v-model="form.customerName" />
              </div>
              <div>
                <div class="appointInfo">卡号:</div>
                <input type="text" maxlength="50" placeholder="请输入卡号" v-model="form.cadCode" />
              </div>
              <div>
                <div class="appointInfo">手机号:</div>
                <input type="text" maxlength="50" placeholder="请输入手机号" v-model="form.mobile" />
              </div>
              <van-button style="width:90%;margin:10px 0" type="danger" round color=" #0297CE"
                @click="getInfo">获取信息</van-button>
              <div>
                <div class="appointInfo">预约就诊时间:</div>
                <div class="selfSelect">
                  <van-field readonly clickable name="datetimePicker" :value="form.appointmentTime" placeholder="请选择"
                    @click="showPicker = true" />
                  <van-popup v-model="showPicker" position="bottom">
                    <van-datetime-picker v-model="dateTime" title="请选择时间" type="datetime" @confirm="onConfirm"
                      @cancel="showPicker = false" :formatter="formatter" @change="changePre" />
                  </van-popup>
                </div>
              </div>
              <div>
                <div class="appointInfo">项目类型:</div>
                <div class="selfSelect">
                  <van-field readonly name="datetimePicker" placeholder="项目类型" v-model="form.projectTypeName"
                    @click="typeShow = true;" />
                  <van-action-sheet v-model="typeShow" :actions="actionsType" @select="onSelectType" />
                </div>
              </div>
            </div>
            <div class="appointBottom">
              <van-cell-group class="arrowLine">
                <!-- <van-field v-model="form.areaName" label="院区:" disabled @click="showArea = true;" /> -->
                <van-field v-model="form.areaName" label="院区:" disabled />
                <van-icon name="arrow" color="#2765C7" />
                <van-action-sheet v-model="showArea" :actions="actionsArea" @select="onArea" />
              </van-cell-group>
              <van-cell-group class="arrowLine">
                <van-field v-model="form.floorName" label="楼层:" disabled @click="checkFloor" />
                <van-icon name="arrow" color="#2765C7" />
                <van-action-sheet v-model="showFloor" :actions="actionsFloor" @select="onFloor" />
              </van-cell-group>
              <van-cell-group class="arrowLine">
                <van-field v-model="form.projectName" label="项目选择:" disabled @click="enterPart(4)" />
                <van-icon name="arrow" color="#2765C7" />
              </van-cell-group>
              <van-cell-group class="arrowLine">
                <van-field v-model="form.hmProjectName" label="宏脉项目名称" disabled />
              </van-cell-group>
              <van-cell-group class="arrowLine">
                <van-field v-model="form.instrumentName" label="仪器:" disabled @click="enterPart(0)" />
                <van-icon name="arrow" color="#2765C7" />
              </van-cell-group>
              <div v-for="(domain, idx) in form.appointmentPosition " :key="idx">
                <van-cell-group class="arrowLine">
                  <van-field v-model="domain.positionNameTime" :label="'部位' + (idx + 1) + ':'" disabled
                    @click="enterPart(1, idx)" />
                  <van-icon name="arrow" color="#2765C7" />
                  <van-icon name="delete-o" color="#F56C6C" @click.prevent="removeDomain(domain, idx)" v-show="idx > 0" />
                </van-cell-group>
              </div>
              <van-cell-group class="arrowLine addArrow">
                <van-field disabled />
                <van-button type="danger" size="mini" round color=" #0297CE" @click="addDomain">新增部位</van-button>
              </van-cell-group>
              <van-cell-group class="arrowLine">
                <van-field v-model="form.doctorName" label="操作人:" disabled @click="enterPart(2)" />
                <van-icon name="arrow" color="#2765C7" />
              </van-cell-group>
              <van-cell-group class="arrowLine">
                <van-field v-model="form.appointStatusList" label="初/复诊:" disabled @click="show = true;" />
                <van-icon name="arrow" color="#2765C7" />
                <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
              </van-cell-group>
              <van-cell-group>
                <van-field v-model="form.remark" label="备注:" />
              </van-cell-group>
            </div>
            <div class="forgetButton" @click="handSubmit">复制</div>
          </van-form>
        </div>
      </div>
    </div>

    <!-- 选择项目内容 -->
    <div class="selectPart" v-show="!addAppointment">
      <div class="vanIndexBar" v-if="flag">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value" :placeholder="placeholderValue" @input="searchInput" />
            </div>
          </div>
        </van-sticky>
        <div class="commonBottom">
          <van-index-bar :sticky-offset-top="stickyOffset" highlight-color="#108EE9">
            <div v-for="(item, index) in textList" :key="index">
              <van-index-anchor :index="item.length != 0 ? index : ''" />
              <van-radio-group v-model="radio">
                <van-cell-group v-for="(list, index) in item" :key="index">
                  <van-cell :title="list.projectName" clickable @click="radio = list.projectId">
                    <template #right-icon>
                      <van-radio :name="list.projectId" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </van-index-bar>
        </div>
        <div class="textSure" @click="sureAdd()">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 选择仪器 -->
      <div class="vanIndexBar" v-if="flag1">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value" :placeholder="placeholderValue" />
            </div>
          </div>
        </van-sticky>
        <div class="commonBottom">
          <van-radio-group v-model="instrucRadio">
            <van-cell-group v-for="(list, index) in instrucmentList" :key="index">
              <van-cell :title="list.instrumentName" clickable @click="
                instrucRadio = list.instrumentId; instrucRadioList = list.instrumentName;">
                <template #right-icon>
                  <van-radio :name="list.instrumentId" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="textSure" @click="addInstrucment()">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 选择操作人 -->
      <div class="vanIndexBar" v-if="flag2">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value2" :placeholder="placeholderValue" />
            </div>
          </div>
        </van-sticky>
        <van-radio-group v-model="doctorRadio">
          <van-cell-group v-for="(list, index) in doctorList" :key="index">
            <van-cell :title="list.doctorName" clickable
              @click="doctorRadio = list.doctorId; doctorRadioList = list.doctorName">
              <template #right-icon>
                <van-radio :name="list.doctorId" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <div class="textSure" @click="addDoctor()">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 选择部位 -->
      <div v-if="flag3" style="margin-bottom:10rem;">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value2" :placeholder="placeholderValue" />
            </div>
          </div>
        </van-sticky>
        <van-radio-group v-model="positionRadio">
          <van-cell-group v-for="(list, index) in positionList" :key="index">
            <van-cell :title="list.positionName + '~' + list.useMinute + '分钟'" clickable
              @click="positionRadio = list.positionId; positionRadioList = list.positionName;">
              <template #right-icon>
                <van-radio :name="list.positionId" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-popup v-model="showInstrucmentTime" position="bottom">
          <van-datetime-picker :filter="filter" v-show="dateFlag" v-model="positionDateTime" title="请选择时间" type="datetime"
            @confirm="positionTime" @cancel="showInstrucmentTime = false" :formatter="formatter" />
          <van-datetime-picker v-show="!dateFlag" v-model="positionDateTime" title="请选择时间" type="datehour"
            @confirm="positionTime" @cancel="showInstrucmentTime = false" :formatter="formatter" />
        </van-popup>

        <div v-if="showTime">
          <van-dropdown-menu :class="valueLabel == 1 ? 'tips' : 'tooltips'">
            <van-dropdown-item v-model="valueLabel" :options="option1" />
          </van-dropdown-menu>
          <div v-if="valueLabel == 0">
            <div v-for="(list, index) in successAppointTime.occupied" :key="index" class="listData">
              <van-tag type="danger" round>{{ list.instrumentDate }}</van-tag>
            </div>
          </div>
          <div v-if="valueLabel == 1">
            <div v-for="(list, index) in successAppointTime.unoccupied" :key="index" class="listData">
              <van-tag type="primary" round>{{ list.instrumentDate }}</van-tag>
            </div>
          </div>
        </div>

        <div class="textSure" @click="addposition()">
          <div class="selectSure">确定</div>
        </div>
      </div>

      <!-- 选择客户信息 -->
      <div v-if="flag4" style="margin-bottom:10rem;">
        <info @reBack="reBack"></info>
      </div>
    </div>
  </div>
</template>
<script>
let pinyin = require('js-pinyin');
import {
  insertOrUpdateAppointment,
  findAppiontmentById,
  findByProjectIdList,
  findProjectBydId,
  findInstrumentById,
  findInstrumentFlag,
  findInstrumentDateById,
  findDoctorByInstrumentDate,
  findDistinguishData,
  getClientInformation
} from "@/axios/api";

import info from './info.vue';
import {
  Toast, Dialog
} from 'vant';
export default {
  components: { info },
  data() {
    return {
      form: {},
      userStatus: '',
      showPicker: false,
      show: false,
      showFloor: false,
      showArea: false,
      addAppointment: true,
      actionsArea: [{
        name: "伯思立",
        id: 'bsl',
      }, , {
        name: "翡立思",
        id: 'fls',
      },],
      actionsFloor: [{
        name: "2楼",
        id: '2',
      }, {
        name: "3楼",
        id: '3',
      }, {
        name: "12楼",
        id: '12',
      }],
      dateTime: new Date(),
      positionDateTime: new Date(),
      actions: [{
        name: "初诊",
        id: 0,
      }, {
        name: "复诊",
        id: 1,
      }, {
        name: "VIP",
        id: 2,
      }],
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      showInstrucmentTime: false,
      projectIdx: '',
      stickyOffset: 62,
      textList: [],
      instrucmentList: [],
      instrucRadio: "",
      doctorList: [],
      positionList: [],
      positionRadio: '',
      doctorRadio: "",
      radio: '',
      projectData: {},
      doctorListAdd: {},
      empId: '',
      value2: '',
      value: '',
      focusTime: '',
      FirstPin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "#"
      ],
      isDel: false,
      valueLabel: 1,
      option1: [
        { text: '当日已预约时间', value: 0 },
        { text: '当日可预约时间', value: 1 },
      ],
      typeShow: false,
      actionsType: [{
        id: '1',
        name: '皮肤'
      }, {
        id: '2',
        name: '注射'
      }, {
        id: '3',
        name: '其他'
      }],
      dateFlag: true,
      areaType: localStorage.getItem('areaType')
    }
  },
  created() {
    this.getDetailInfo(this.$route.query.appointmentId)
  },
  beforeRouteLeave(to, from, next) {
    console.log(to.name)
    if (to.name == 'index') {
      to.meta.ifDoFresh = this.isDel;
      console.log(to.meta.ifDoFresh)
    }
    next();
  },
  methods: {
    getInfo() {
      if (this.form.cadCode == '' && this.form.mobile == '') {
        _g.toast("warning", '请填写手机号或卡号');
        return;
      }
      this.loadOption = []
      localStorage.setItem("selected", 1)
      this.loading = true
      let data = {
        clientCard: this.form.cadCode,
        clientMobile: this.form.mobile,
        clientName: this.form.customerName,
        pageIndex: 1,
      }

      getClientInformation(data)
        .then((res) => {
          console.log(res)
          if (res.result == true) {
            this.loading = false
            if (res.data.mapList.length == 1) {
              this.form.mobile = res.data.mapList[0].clientMobile
              this.form.cadCode = res.data.mapList[0].clientCard
              this.form.customerName = res.data.mapList[0].clientName
              this.$forceUpdate()
            } else {
              this.flag = false;
              this.flag1 = false;
              this.flag2 = false;
              this.flag3 = false;
              this.flag4 = true;
              this.addAppointment = false;
              this.loadOptions = res.data.mapList
            }
          } else if (res.result == false) {
            this.loading = false
            //   获取信息之后是否可以编辑信息
            this.disabled = false
            _g.toast("warning", '请手动添加客户信息');
          }
        }).catch((err) => {
          this.loading = false
        })
    },
    reBack(obj) {
      console.log(obj);
      this.flag = false;
      this.flag1 = false;
      this.flag2 = false;
      this.flag3 = false;
      this.flag4 = false;
      this.addAppointment = true;
      if (obj) {
        this.form.customerName = obj.clientName
        this.form.mobile = obj.clientMobile
        this.form.cadCode = obj.clientCard
      }

    },
    getDetailInfo(ID) {
      let data = {
        appointmentId: ID
      }
      findAppiontmentById(data)
        .then((res) => {
          if (res.result == true) {
            console.log(res.data)
            let detailData = res.data
            this.form = JSON.parse(JSON.stringify(detailData.appointmentInfo));
            this.form.appointmentPosition = detailData.appointmentPosition
            //   编辑时部位以及仪器部位使用时间回显
            detailData.appointmentPosition.forEach(ele => {
              ele.positionNameTime = ele.positionName + '(' + ele.useTimeStart.split(' ')[1] + ')'
              // ele.positionNameTime = ele.positionName + '(' + ele.useTimeStart + ')'
              ele.useTime = ele.useTimeStart
            });
            if (detailData.appointmentInfo.appointStatus == 2) {
              this.form.appointStatusList = 'VIP'
            } else if (detailData.appointmentInfo.appointStatus == 1) {
              this.form.appointStatusList = '复诊'
            } else if (detailData.appointmentInfo.appointStatus == 0) {
              this.form.appointStatusList = '初诊'
            }
            if (detailData.appointmentInfo.projectType == '3') {
              this.form.projectTypeName = '其他'
            } else if (detailData.appointmentInfo.projectType == '2') {
              this.form.projectTypeName = '注射'
            } else if (detailData.appointmentInfo.projectType == '1') {
              this.form.projectTypeName = '皮肤'
            }
            if (detailData.appointmentInfo.floorCode == '12') {
              this.form.floorName = '12楼'
            } else if (detailData.appointmentInfo.floorCode == '3') {
              this.form.floorName = '3楼'
            } else if (detailData.appointmentInfo.floorCode == '2') {
              this.form.floorName = '2楼'
            }
            if (detailData.appointmentInfo.areaCode == 'bsl') {
              this.form.areaName = '伯思立'
            } else if (detailData.appointmentInfo.areaCode == 'fls') {
              this.form.areaName = '翡立思'
              this.form.floorName = '1楼'
              this.form.floorCode = '1'
            } else if (detailData.appointmentInfo.areaCode == 'ntbsl') {
              this.form.areaName = '南通伯思立'
              this.form.floorName = '1楼'
              this.form.floorCode = '1'
            }
          } else {
            console.log(res.errMsg)
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.fail(err.errMsg);
        });
    },
    checkFloor() {
      if (this.areaType == 'bsl') {
        this.showFloor = true;
      } else if (this.areaType == 'fls') {
        this.showFloor = false;
      }
    },
    // 跳转选择详情
    enterPart(item, idx) {
      this.showTime = false
      this.projectIdx = idx;
      // 点击时携带的数字
      this.projectItem = item;
      if (this.projectItem == 4) {
        if (!this.form.appointmentTime) {
          this.$toast.success("请先填写预约门诊时间");
          return;
        } else if (!this.form.areaName) {
          this.$toast.success("请先填写院区");
          return;
        } else if (!this.form.floorName) {
          this.$toast.success("请先填写楼层");
          return;
        } else {
          this.addAppointment = false;
          this.flag = true;
          this.flag1 = false;
          this.flag2 = false;
          this.flag3 = false;
          this.flag4 = false;
          this.radio = "";
          this.value = ''
          this.placeholderValue = "请搜索项目";
          this.form.positionNameTime = ''
          this.form.instrumentName = ''
          this.form.instrumentId = ''
          this.form.doctorName = ''
          this.form.doctorId = ''
          this.form.appointmentPosition = [{
            positionId: '',
            positionName: '',
            positionNameTime: '',
            useTime: '',
          }]
          this.findprojectList('');
        }
      } else if (this.projectItem == 0) {
        console.log(this.form)
        if (!this.form.projectId) {
          this.$toast.success("请先选择项目");
          return;
        }
        this.instrucmentList = []
        this.addAppointment = false;
        this.flag = false;
        this.flag1 = true;
        this.flag2 = false;
        this.flag3 = false;
        this.flag4 = false;
        this.form.instrumentName = ''
        this.form.instrumentId = ''
        this.form.doctorName = ''
        this.form.doctorId = ''
        this.instrucRadio = ''
        this.instrucRadioList = ''
        this.value1 = ''
        this.placeholderValue = "请搜索仪器";
        this.form.appointmentPosition = [{
          positionId: '',
          useTime: '',
          positionName: '',
          positionNameTime: '',
        }]
        // 跳转选择仪器
        findProjectBydId({
          id: this.form.projectId,
          areaCode: this.form.areaCode,
          floorCode: this.form.floorCode
        }).then((res) => {
          if (res.result == true) {
            this.projectData = res.data;
            // this.instrucmentList = res.data.instrumentNames.split(",");
            this.instrucmentList = res.data.projectInstrument;
          }
        });
      } else if (this.projectItem == 2) {
        // 跳转选择操作人
        console.log('this.form.instrumentId')
        console.log(this.form)
        if (!this.form.projectId) {
          this.$toast.success("请先选择项目");
          return;
        }
        if (this.form.instrumentId == '' || !this.form.instrumentId) {
          this.$toast.success("请先选择仪器");
          return;
        }
        if (this.form.appointmentPosition.length == 1 && this.form.appointmentPosition[0].positionId == '') {
          this.$toast.success("请先选择部位");
          return;
        }
        this.doctorList = []
        this.addAppointment = false;
        this.flag = false;
        this.flag1 = false;
        this.flag2 = true;
        this.flag3 = false;
        this.flag4 = false;
        this.form.doctorName = ''
        this.doctorRadio = ''
        this.doctorRadioList = ''
        this.value2 = ''
        this.placeholderValue = "请搜索操作人";
        findProjectBydId({
          id: this.form.projectId,
          areaCode: this.form.areaCode,
          floorCode: this.form.floorCode
        }).then((res) => {
          if (res.result == true) {
            this.projectData = res.data;
            this.doctorListAdd = res.data.projectDoctor;
            // 根据选择仪器时间筛选操作人
            let arrForm = []
            this.doctorListAdd.forEach(ele => {
              arrForm.push(ele.doctorId)
            });
            this.$forceUpdate()
            findDoctorByInstrumentDate({
              appointmentTime: this.form.appointmentTime,
              doctorIds: arrForm,
              instrumentId: this.form.instrumentId,
              appointmentPosition: this.form.appointmentPosition,
              choiceDoctorId: this.form.doctorId,
            }).then((res) => {
              if (res.result == true) {
                let resData = res.data
                // 筛选id相同的医生数据
                if (resData.length != 0) {
                  let add = this.doctorListAdd.filter(item => resData.some(ele =>
                    ele.doctorId === item.doctorId))
                  add.push({
                    doctorId: '999999',
                    doctorName: '无指定操作人'
                  })
                  this.doctorList = add
                  console.log('this.doctorList')
                  console.log(this.doctorList)
                } else if (resData.length == 0) {
                  this.doctorList = [{
                    doctorId: '999999',
                    doctorName: '无指定操作人'
                  }]
                }
              }
            });
          } else {
            this.$toast.fail(res.errMsg);
          }
        });
      } else if (this.projectItem == 1) {
        console.log('点击选择部位时的this.form')
        console.log(this.form)
        if (this.form.instrumentId == '') {
          this.$toast.success("请先选择仪器");
          return;
        }
        this.positionRadio = this.form.appointmentPosition[idx].positionId
        this.positionRadioList = this.form.appointmentPosition[idx].positionName
        this.placeholderValue = "请搜索部位";
        this.addAppointment = false;
        this.flag = false;
        this.flag1 = false;
        this.flag2 = false;
        this.flag3 = true;
        this.flag4 = false;
        // 根据仪器id查找部位
        findInstrumentById({
          instrumentId: this.form.instrumentId
        })
          .then((res) => {
            console.log(res.data.InstrumentPosition);
            if (res.result == true) {
              this.$nextTick(() => {
                this.positionList = res.data.InstrumentPosition
                this.positionList.map((x, i) => {
                  this.form.appointmentPosition.map((s) => {
                    if (x.positionId === s.positionId) {
                      x.disabled = true
                    }
                  })
                })
                this.$forceUpdate()
                // 筛选仪器部位已经使用的时间
                findInstrumentDateById({
                  appointmentTime: this.form.appointmentTime,
                  instrumentId: this.form.instrumentId,
                })
                  .then((res) => {
                    console.log(res.data)
                    if (res.result == true) {
                      let dataTimeAppoint = res.data
                      if (dataTimeAppoint.unoccupied) {
                        this.showTime = true
                        this.successAppointTime = dataTimeAppoint
                      } else if (!dataTimeAppoint.unoccupied) {
                        this.showTime = false
                      }
                    }
                    this.$forceUpdate()
                  })
              });
            } else {
              console.log(res.errMsg)
              this.$toast.fail(res.errMsg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toast.fail(err.errMsg);
          });
      }
    },
    // 返回添加预约
    returnIndexList() {
      this.addAppointment = true;
    },
    // 时间间隔过滤,时间间隔五分钟
    filter(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 5 === 0);
      }
      return options;
    },
    // 选择项目关键字查询
    searchInput(val) {
      if (this.flag = true) {
        console.log(val)
        this.findprojectList(val);
      }
    },
    isSameDay(dateA, dateB) {
      const { getFullYear, getMonth, getDate } = Date.prototype
      return [getFullYear, getMonth, getDate].every(fn => {
        return fn.call(dateA) === fn.call(dateB)
      })
    },
    positionTime(time) {
      var time1 = this.form.appointmentTime.replace(/-/g, '/');
      var oDate1 = new Date(time1);
      var oDate2 = new Date(time);
      if (oDate1) {
        if (oDate1.getTime() > oDate2.getTime()) {
          this.$toast.success("预约仪器时间不得早于预约门诊时间!");
          return; //第一个大
        }
        if (this.isSameDay(oDate1, oDate2) == false) {
          this.$toast.success("预约仪器时间不得超过当天!");
          return; //第二个大
        }
      }
      findInstrumentFlag({
        instrumentName: this.form.instrumentName,
        instrumentId: this.form.instrumentId,
        positionId: this.positionRadio,
        instrumentDate: this.getDate(time)
      })
        .then((res) => {
          console.log(res.result)
          if (res.result == true) {
            this.$toast.success("选择仪器使用时间成功");
            this.form.appointmentPosition[this.projectIdx].useTime = this.getDate(time);
            this.addAppointment = true;
            this.showInstrucmentTime = false;
            console.log('this.form.appointmentPosition[this.projectIdx].positionName')
            console.log(this.form)
            // 选中仪器携带时间
            let dateTimeNow = this.form.appointmentPosition[this.projectIdx].useTime.split(' ')[1]
            this.form.appointmentPosition[this.projectIdx].positionNameTime = this.form.appointmentPosition[this
              .projectIdx].positionName + '(' + dateTimeNow + ')'
          } else if (res.result == false) {
            this.$toast.success(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.success(err.errMsg);
        });
    },
    // 查询项目接口
    findprojectList(projectName) {
      findByProjectIdList({
        projectName: projectName,
        projectType: this.form.projectType,
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType'),
        cityCode: localStorage.getItem('cityCode'),
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            var cities = res.data;
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.projectName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.projectName = el.projectName.slice(0, 0) + '#' + el.projectName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            this.$nextTick(() => {
              this.textList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 确定提交选中项目
    sureAdd() {
      this.addAppointment = true;
      this.form.projectId = this.radio;
      findProjectBydId({
        id: this.radio,
        areaCode: this.form.areaCode,
        floorCode: this.form.floorCode
      })
        .then((res) => {
          if (res.result == true) {
            this.projectData = res.data;
            this.form.projectName = this.projectData.projectName;
            this.form.hmProjectName = this.projectData.hmProjectName;
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 确定添加仪器
    addInstrucment() {
      this.addAppointment = true;
      this.showInstrucmentTime = false;
      this.form.instrumentName = this.instrucRadioList;
      this.form.instrumentId = this.instrucRadio
    },
    // 确定添加操作人
    addDoctor() {
      this.form.doctorName = this.doctorRadioList;
      this.form.doctorId = this.doctorRadio;
      console.log(this.doctorRadio)
      if (this.doctorRadio == '') {
        this.$toast.success("请选择操作人");
        return;
      } else {
        this.addAppointment = true;
      }
    },
    // 确定添加部位
    addposition() {
      if (this.positionRadio == '') {
        this.$toast.success("请选择部位");
        return;
      } else {
        this.showInstrucmentTime = true;
      }

      this.form.appointmentPosition[this.projectIdx].positionName = this.positionRadioList;
      this.form.appointmentPosition[this.projectIdx].positionId = this.positionRadio;
      this.dateFlag = true
      this.showOrHide(this.form.projectName)
    },
    // 仪器部位时间选择器切换
    showOrHide(projectName) {
      let ss = projectName.includes('热拉提')
      let vv = projectName.includes('热玛吉')
      if (ss == true || vv == true) {
        this.dateFlag = !this.dateFlag
      } else {
        this.dateFlag = true
      }
    },
    // 新增部位
    addDomain() {
      this.form.appointmentPosition.push({
        positionId: '',
        positionName: '',
        positionNameTime: '',
        useTime: '',
        key: Date.now()
      });
      this.$forceUpdate()
    },
    // 删除部位
    removeDomain(item, idx) {
      var index = this.form.appointmentPosition.indexOf(item)
      if (index !== -1) {
        this.form.appointmentPosition.splice(idx, 1)
      }
      this.$forceUpdate()
    },
    // 添加预约返回首页
    returnIndex() {
      this.$router.replace('/index')
    },
    handSubmit() {
      this.isDel = true;
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      let data = JSON.parse(JSON.stringify(this.form))
      console.log('初始数据data')
      console.log(data)
      var dataList = {
        AppointmentProject: [{
          projectName: data.projectName,
          instrumentName: data.instrumentName,
          doctorName: data.doctorName,
          operationStatus: 3,
          projectInstrument: [{
            instrumentId: data.instrumentId
          }],
          projectDoctor: [{
            doctorId: data.doctorId
          }],
          remark: data.remark,
          appointmentPosition: data.appointmentPosition,
          id: data.projectId,
          appointStatus: data.appointStatus,
          projectId: data.projectId,
          areaCode: data.areaCode,
          floorCode: data.floorCode,
          areaName: data.areaName,
          floorName: data.floorName,
        }],
        customerName: data.customerName,
        mobile: data.mobile,
        appointmentTime: data.appointmentTime,
        userId: this.empId,
        projectType: data.projectType,
        cadCode: data.cadCode
      }
      if (!data.projectType || data.projectType == null || data.projectType == 'null') {
        dataList.projectType = ''
      } else {
        dataList.projectType = data.projectType
      }
      if (dataList.doctorName == '' || dataList.doctorId == '') {
        this.$toast.success("操作人不能为空！")
        return;
      }
      console.log("this.form最后提交的数据")
      console.log(dataList)
      var that = this
      // / 重复预约识别
      let sureData = {
        mobile: dataList.mobile,
        customerName: dataList.customerName,
        projectId: data.projectId, // 项目id集合
        appointmentId: '',// 修改时必传
        status: 1,// 1：新增 2：修改
        appointmentTime: dataList.appointmentTime.split(' ')[0]
      }
      dataList.areaType = localStorage.getItem('areaType')
      dataList.areaCode = localStorage.getItem('areaType')
      findDistinguishData(sureData).then((res) => {
        if (res.data != 0) {
          Dialog.confirm({
            message: '该客户在当前时间已预约过此项目,是否确定要重复预约？',
            confirmButtonColor: '#108EE9'
          }).then(() => {
            that.insertOrUpdateList(dataList)
          }).catch(() => {
            // on cancel
          });
        } else if (res.data == 0) {
          that.insertOrUpdateList(dataList)
        }
      })
    },
    insertOrUpdateList(dataList) {
      insertOrUpdateAppointment(dataList)
        .then((res) => {
          if (res.result == true) {
            if (res.data != '' && res.data != '已预约（0)次') {
              Dialog.alert({
                message: res.data,
                confirmButtonColor: '#108EE9'
              }).then(() => {
                this.$router.push("/index");
              }).catch(() => {
              });
            } else {
              this.$router.push("/index");
            }
          } else {
            this.$toast.fail(err.errMsg);
          }
        })
        .catch((err) => {
          this.$toast.fail(err.errMsg);
        });
    },
    // 日期组件日期格式化
    formatter(type, val) {
      if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "year") {
        return `${val}年`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    CompareDate(t1, t2) {
      var date = new Date();
      var a = t1.split(":");
      var b = t2.split(":");
      return date.setHours(a[0], a[1]) > date.setHours(b[0], b[1]);
    },
    onConfirm(time) {
      var ee = this.getDate(time).split(' ')[1]
      var ff = '08:59:59'
      if (this.CompareDate(ee, ff) == false) {
        this.$toast.success("请选择九点之后的时间");
        return;
      }
      this.showPicker = false;
      this.form.appointmentTime = this.getDate(time);
      let year1 = this.form.appointmentTime.split('-')[0]
      let year2 = this.focusTime.split('-')[0]
      let month1 = this.form.appointmentTime.split('-')[1]
      let month2 = this.focusTime.split('-')[1]
      let day1 = this.form.appointmentTime.split('-')[2].substring(0, 2)
      if (this.focusTime != '') {
        var day2 = this.focusTime.split('-')[2].substring(0, 2)
      }
      if (year1 == year2 && month1 == month2 && day1 == day2) {
        console.log('同一天')
      } else {
        console.log('时间变化')
        // 修改预约门诊时间时直接修改预约仪器部位时间
        if (this.form.appointmentPosition[0].useTime != '') {
          this.form.appointmentPosition.forEach((ele, idx) => {
            let aa = ele.useTime.split(' ')[1]
            let bb = this.form.appointmentTime.split(' ')[0]
            ele.useTime = bb + ' ' + aa
            ele.useTimeStart = bb + ' ' + aa
            ele.positionNameTime = ele.positionName + '(' + ele.useTimeStart.split(' ')[1] + ')'
            this.$forceUpdate()
          });
        }
        // // 根据预约门诊时间和仪器id提示仪器已预约时间
        if (this.form.instrumentId != '') {
          findInstrumentDateById({
            appointmentTime: this.form.appointmentTime,
            instrumentId: this.form.instrumentId,
          })
            .then((res) => {
              console.log(res.data)
              if (res.result == true) {
                let dataTimeAppoint = res.data
                if (dataTimeAppoint.unoccupied) {
                  this.showTime = true
                  this.successAppointTime = dataTimeAppoint
                } else if (!dataTimeAppoint.unoccupied) {
                  this.showTime = false
                }
              }
              this.$forceUpdate()
            })
        }
      }
    },
    // 预约时间修改后清空数据
    changePre(val) {
      if (this.form.appointmentTime) {
        this.focusTime = this.form.appointmentTime
      }
      this.form.doctorId = ''
      this.form.doctorName = ''
    },
    onSelectType(item) {
      // 默认情况下点击选项时不会自动收起
      this.typeShow = false;
      this.form.projectTypeName = item.name;
      this.form.projectType = item.id;


      this.form.areaCode = ''
      this.form.areaName = ''
      this.form.floorCode = ''
      this.form.floorName = ''
      this.form.instrumentId = ''
      this.form.instrumentName = ''
      this.form.doctorId = ''
      this.form.doctorName = ''
      this.form.projectId = ''
      this.form.projectName = ''
      this.form.remark = ''
      this.form.dateFlag = true
      this.form.appointStatus = ''
      this.form.appointStatusList = ''
      this.showTime = false
      this.form.appointmentPosition = [{
        positionId: '',
        useTime: '',
        positionName: '',
        positionNameTime: '',
      }]
      if (this.areaType == 'bsl') {
        this.form.areaCode = 'bsl'
        this.form.areaName = '伯思立'
      } else if (this.areaType == 'fls') {
        this.form.areaCode = 'fls'
        this.form.areaName = '翡立思'
        this.form.floorCode = '1'
        this.form.floorName = '1楼'
      } else if (this.areaType == 'ntbsl') {
        this.form.areaCode = 'ntbsl'
        this.form.areaName = '南通伯思立'
        this.form.floorCode = '1'
        this.form.floorName = '1楼'
      }
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      this.show = false;
      console.log(item);
      this.form.appointStatusList = item.name;
      this.form.appointStatus = item.id;
    },
    onFloor(item) {
      this.showFloor = false;
      this.form.floorCode = item.id
      this.form.floorName = item.name
      // 楼层值变化的时候清空数据
      this.form.positionNameTime = ''
      this.form.instrumentName = ''
      this.form.instrumentId = ''
      this.form.doctorName = ''
      this.form.doctorId = ''
      this.form.appointmentPosition = [{
        positionId: '',
        positionName: '',
        positionNameTime: '',
        useTime: '',
      }]
      this.form.projectName = ''
      this.form.projectId = ''
    },
    onArea(item) {
      this.showArea = false;
      this.form.areaCode = item.id
      this.form.areaName = item.name
    },
    // 时间戳转换成日期
    getDate(timetamp) {
      //let myDate = new Date()如果是要获取当前时间的显示就不传参数
      let myDate = new Date(timetamp); //获取js时间
      let year = myDate.getFullYear(); //获取年
      let month = myDate.getMonth() + 1; //获取月
      let date = myDate.getDate(); //获取日
      let h = myDate.getHours(); //获取小时数(0-23)
      let m = myDate.getMinutes(); //获取分钟数(0-59)
      let s = myDate.getSeconds();
      //获取当前时间连接成的字符串
      let now =
        year +
        "-" +
        this.conver(month) +
        "-" +
        this.conver(date) +
        " " +
        this.conver(h) +
        ":" +
        this.conver(m) +
        ":" +
        this.conver(s);
      return now;
    },
    //日期时间处理
    conver(s) {
      return s < 10 ? "0" + s : s;
    },
  },

}

</script>
<style scoped>
@import "../../assets/css/editAppointment.css";
@import "../../assets/css/selectPart.css";
</style>



// WEBPACK FOOTER //
// src/components/page/copyAppointment.vue